module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns-house_spot_02-675492c91d4a15fa44ecd7af6729d022.jpg";